'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TextField = require('material-ui/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Material-ui [TextField](http://www.material-ui.com/#/components/text-field) extended with an info field.
 *
 * ```
 * <InfoTextField
 *     floatingLabelText="My text field"
 *     infoText="With extra infotext added"
 *     wrapStyle={{flex: 1}}
 *     required={true}
 * />
 * ```
 */
var InfoTextField = function (_React$Component) {
    _inherits(InfoTextField, _React$Component);

    function InfoTextField() {
        _classCallCheck(this, InfoTextField);

        return _possibleConstructorReturn(this, (InfoTextField.__proto__ || Object.getPrototypeOf(InfoTextField)).apply(this, arguments));
    }

    _createClass(InfoTextField, [{
        key: 'render',


        /**
         * @return {Node}
         */

        /**
         * @type {Object}
         * @property {string} infoText
         * @property {Object} wrapStyle Styles added to wrapping element.
         * @property {boolean} fullWidth Default false.
         * @property {Node} floatingLabelText
         * @property {boolean} required Mark field as required. Default false.
         */
        value: function render() {
            var _props = this.props,
                infoText = _props.infoText,
                wrapStyle = _props.wrapStyle,
                fullWidth = _props.fullWidth,
                floatingLabelText = _props.floatingLabelText,
                required = _props.required,
                other = _objectWithoutProperties(_props, ['infoText', 'wrapStyle', 'fullWidth', 'floatingLabelText', 'required']);

            var muiTheme = this.context.muiTheme;


            var floatinglabel = floatingLabelText ? required ? _react2.default.createElement(
                'span',
                null,
                floatingLabelText,
                ' ',
                _react2.default.createElement(
                    'span',
                    { style: { color: muiTheme.baseTheme.palette.accent1Color } },
                    '*'
                )
            ) : floatingLabelText : null;
            return _react2.default.createElement(
                'div',
                { style: Object.assign({ width: fullWidth ? '100%' : 256, display: 'inline-block' }, wrapStyle) },
                _react2.default.createElement(_TextField2.default, _extends({}, other, {
                    floatingLabelText: floatinglabel,
                    fullWidth: fullWidth
                })),
                _react2.default.createElement(
                    'div',
                    { style: {
                            color: muiTheme.textField.hintColor,
                            fontSize: '0.8rem',
                            width: fullWidth ? '100%' : 256
                        } },
                    infoText
                )
            );
        }

        /**
         * @type {Object}
         * @property {Object} muiTheme Theme
         */

    }]);

    return InfoTextField;
}(_react2.default.Component);

InfoTextField.propTypes = {
    infoText: _propTypes2.default.string,
    wrapStyle: _propTypes2.default.object,
    fullWidth: _propTypes2.default.bool,
    floatingLabelText: _propTypes2.default.node,
    required: _propTypes2.default.bool
};
InfoTextField.contextTypes = {
    muiTheme: _propTypes2.default.object.isRequired
};
exports.default = InfoTextField;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ntnu-react/material/InfoTextField.js
// module id = 205
// module chunks = 0